import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "dialog-inner" }
const _hoisted_2 = { class: "dialog-content" }
const _hoisted_3 = { class: "dialog-content-main" }
const _hoisted_4 = {
  key: 2,
  class: "dialog-btns"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: ["dialog-wrapper", [_ctx.dialogData.type && 'dialog-' + _ctx.dialogData.type + '-wrapper']]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          (_ctx.dialogData.text)
            ? (_openBlock(), _createBlock("p", {
                key: 0,
                innerHTML: _ctx.dialogData.text
              }, null, 8, ["innerHTML"]))
            : _createCommentVNode("", true),
          (_ctx.dialogData.subText)
            ? (_openBlock(), _createBlock("p", {
                key: 1,
                class: "sub-text",
                innerHTML: _ctx.dialogData.subText
              }, null, 8, ["innerHTML"]))
            : _createCommentVNode("", true),
          (_ctx.dialogData.btns)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogData.btns, (btn) => {
                  return (_openBlock(), _createBlock("div", {
                    class: ["dialog-btn", [btn.className]],
                    onClick: ($event: any) => (_ctx.btnClick(btn))
                  }, [
                    _createVNode("span", null, _toDisplayString(btn.text), 1)
                  ], 10, ["onClick"]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 2))
}